/**
 * 🖼️ IMAGE CONSTANTS
 *
 * Centralized image paths for consistent usage across the application.
 * This prevents hardcoded image paths scattered throughout the codebase.
 */

export const DEFAULT_IMAGES = {
  // Fighter default images
  FIGHTER_GENERIC: '/default_fighter.png',
  FIGHTER_MALE: '/default_fighter_dark_blue.png',
  FIGHTER_FEMALE: '/default_fighter_dark_red.png',

  // Other default images
  // TO BE IMPLEMENTED TO USE THIS INSTEAD OF HARDCODING IN NEW PR
  LOGO: '/fantasy_mma_logo.png',
  UFC_LOGO: '/ufc_logo.png',
  OCTAGON: '/viewer_octagon.png',
  PICKER_BACKGROUND: '/picker_background.png',
} as const;

/**
 * Typed image paths to ensure type safety
 */
export type DefaultImage = (typeof DEFAULT_IMAGES)[keyof typeof DEFAULT_IMAGES];
